export default __webpack_public_path__ + "static/media/custom-reports-guide-share.060a86aa.png";